export class Guid {
    public static getNext(): string {
        this.next++;
        return "__GUID_" + (this.next + 1000);
    }
    private static next = 0;
}
